exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".client-content{min-height:calc(100vh - 221px)}.client-title{font-family:NanumBarunGothicOTF;font-size:32px;margin-bottom:30px;font-weight:400}.client-down-box{width:80%;height:276px;border-radius:3px;box-shadow:0 10px 60px 0 hsla(0,0%,85%,.43);background-color:#fff;display:flex;flex-direction:column;align-items:center;justify-content:center}.client-down-tag{height:46px;font-size:40px}.client-down-button,.client-down-tag{font-family:NanumBarunGothicOTF;text-align:center}.client-down-button{width:416px;height:64px;border-radius:3px;box-shadow:0 3px 10px 0 rgba(75,116,255,.6);background-color:#4b74ff;font-size:20px;line-height:64px;color:#fff;cursor:pointer;border:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f6a54f26","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MarketManager/ClientDownload.vue
// module id = 196
// module chunks = 0